import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import {
  uploadFileToS3,
  preSignedUrl,
  postSampleTemplate,
  fetchServiceMetaData
} from '../actions/sessionActions';
import { Select, Radio, Button, Row, Col, message, Input } from 'antd';
const { Option } = Select;
import { getBase64 } from '../utils/assetUtils';

const labelSizes = [
  { label: 'A4', value: 'A4' },
  { label: 'A6', value: 'A6' },
  { label: '6X4', value: '6X4' }
];

export class CreateSampleTemplate extends Component {
  state = {
    formInput: {
      name: null,
      cps: [],
      file: {},
      labelSize: ''
    },
    isSubmitting: false
  };
  htmlTemplate = React.createRef();
  componentWillMount = () => {
    this.props.fetchServiceMetaData();
  };

  handleInputChange = e => {
    const { formInput } = this.state;
    formInput[e.target.name] = e.target.value;
    this.setState({ formInput });
  };

  handleChange = (key, value) => {
    const { formInput } = this.state;
    formInput[key] = value;
    this.setState({ formInput });
  };

  handleRadioChange = e => {
    const { formInput } = this.state;
    formInput[e.target.name] = e.target.value;
    formInput.file = {};
    this.htmlTemplate.current.value = null;
    this.setState({ formInput });
  };

  fileSelect = e => {
    const { formInput } = this.state;
    formInput.file = e.target.files[0];
    formInput.sampleTemplate = '';
    this.setState({ formInput });
  };

  handleSubmit = () => {
    const { sampleTemplates } = this.props;
    const { formInput } = this.state;
    if (!formInput.name) {
      return message.info('Please select label size');
    }
    if (formInput.cps.length < 1) {
      return message.info('Please select courier partner');
    }
    if (!formInput.labelSize) {
      return message.info('Please select label size');
    }
    if (!formInput.file.name) {
      return message.info('Please select shipping label template');
    }
    this.setState({ isSubmitting: true });
    let preUrl = `${sampleTemplates.file.directory}_${formInput.name}`;
    if (formInput.file.type === 'text/html' || formInput.sampleTemplate) {
      preUrl += '.html';
    } else {
      preUrl += formInput.file.name;
    }
    const obj = {
      name: formInput.name,
      tags: {},
      file_upload: preUrl,
      label_size: formInput.labelSize
    };
    for (let index = 0; index < formInput.cps.length; index++) {
      obj.tags[formInput.cps[index]] = formInput.cps[index];
    }
    if (formInput.file.name) {
      getBase64(formInput.file, () => {
        this.props.preSignedUrl(preUrl).then(res => {
          if (res) {
            const { url, fields } = res;
            this.props
              .uploadFileToS3({ file: formInput.file, url, fields })
              .then(() => {
                this.props.postSampleTemplate(obj).then(resp => {
                  if (resp) {
                    this.setState({ isSubmitting: false });
                  }
                });
              });
          }
        });
      });
    }
  };

  handleReset = () => {
    this.setState({
      formInput: {
        name: null,
        cps: [],
        file: {},
        labelSize: ''
      }
    });
    this.htmlTemplate.current.value = null;
  };

  render() {
    const { formInput } = this.state;
    const { metadata } = this.props;
    return (
      <div>
        <h2>Set Sample Template</h2>
        <Row className="margin-bottom-10">
          <Col span={3}>
            <span>Name:</span>
          </Col>
          <Col span={21} className="margin-bottom-10">
            <Input
              name="name"
              placeholder={`Enter name here`}
              className="ant-input"
              value={formInput.name}
              onChange={this.handleInputChange}
            />
          </Col>
          <Col span={3}>
            <span>Courier Partner:</span>
          </Col>
          <Col span={21} className="margin-bottom-10">
            <Select
              placeholder="Please select courier partner"
              value={formInput.cps.length > 0 ? formInput.cps : undefined}
              mode="multiple"
              style={{ width: '100%' }}
              onChange={value => this.handleChange('cps', value)}
              filterOption={(input, option) =>
                option.props.children
                  .toLowerCase()
                  .indexOf(input.toLowerCase()) >= 0
              }
            >
              {metadata.cp.list.map((cp, i) => (
                <Option key={i} value={cp.name}>
                  {cp.name}
                </Option>
              ))}
            </Select>
          </Col>
          <Col span={3}>
            <span>Label Size:</span>
          </Col>
          <Col span={21} className="margin-bottom-10">
            <Radio.Group
              name="labelSize"
              value={this.state.formInput.labelSize}
              onChange={this.handleRadioChange}
            >
              {labelSizes.map((item, i) => (
                <Radio key={i} value={item.value}>
                  {item.label}
                </Radio>
              ))}
            </Radio.Group>
          </Col>
          <Col span={3}>
            <span>Upload:</span>
          </Col>
          <Col span={21} className="margin-bottom-20">
            <input
              type="file"
              ref={this.htmlTemplate}
              name="htmlTemplate"
              accept=".html"
              onChange={this.fileSelect}
            />
          </Col>
          <Col span={24} className="margin-bottom-20">
            <Button
              type="primary"
              onClick={this.handleSubmit}
              loading={this.state.isSubmitting}
            >
              Submit
            </Button>
            <Button
              style={{ marginLeft: 8 }}
              onClick={this.handleReset}
              disabled={this.state.isSubmitting}
            >
              Clear
            </Button>
          </Col>
        </Row>
      </div>
    );
  }
}

CreateSampleTemplate.propTypes = {
  sampleTemplates: PropTypes.object,
  metadata: PropTypes.object,
  uploadFileToS3: PropTypes.func,
  preSignedUrl: PropTypes.func,
  postSampleTemplate: PropTypes.func,
  fetchServiceMetaData: PropTypes.func
};

CreateSampleTemplate.contextTypes = {
  router: PropTypes.object.isRequired
};

const mapStateToProps = state => ({
  config: state.session.config,
  metadata: state.session.metadata,
  sampleTemplates: state.session.sampleTemplates
});

const mapDispatchToProps = dispatch => ({
  uploadFileToS3: query => dispatch(uploadFileToS3(query)),
  preSignedUrl: query => dispatch(preSignedUrl(query)),
  postSampleTemplate: query => dispatch(postSampleTemplate(query)),
  fetchServiceMetaData: () => dispatch(fetchServiceMetaData())
});

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(CreateSampleTemplate)
);
